import { render, staticRenderFns } from "./D_MixologiaGold.vue?vue&type=template&id=484aef36&scoped=true&"
import script from "./D_MixologiaGold.vue?vue&type=script&lang=js&"
export * from "./D_MixologiaGold.vue?vue&type=script&lang=js&"
import style0 from "./D_MixologiaGold.vue?vue&type=style&index=0&id=484aef36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484aef36",
  null
  
)

export default component.exports